import React, { VFC } from 'react'

import {
  PersonalisationModalLayout,
} from '@Components/Personalization/Layout/PersonalizationModalLayout'
import { PersonalisationModal } from '@Components/Personalization/Modals/Shared'

const info = {
  title: 'products:DEBOSSING_OPTIONS',
  list: [
    'products:NO_DELAY_ON_DEBOSSED_PRODUCTS',
    'products:SAME_FONT_AND_TEXT_SIZE_ADJUSTMENT_INFO',
    'products:DEBOSSED_PRODUCTS_ARE_NOT_RETURNABLE',
  ],
}

export const DebossModal: VFC<PersonalisationModal> = props => (
  <PersonalisationModalLayout
    info={info}
    {...props}
    type="deboss"
  />
)
